import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CDN_SERVER_PREFIX}/excel`
const endpoints = {
    getExcelData: () => `${RESOURCE_ENDPOINT}`,
}

export default class ExcelApi {
    public getExcelData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getExcelData();
        return HttpService.post(url, payload, params, headers);
    }
}